import { useCallback } from 'react';

export function useMintEarlyExplorerNft(account, etherQuizWorldContract) {
    return useCallback(async () => {

        try {
            await etherQuizWorldContract.methods.mintEarlyExplorerNFT()
                .send({
                    from: account,
                    maxPriorityFeePerGas: '0x0',
                    maxFeePerGas: '0x5F5E100',
                    gas: '0x88A19C' });
        } catch (err) {
            console.error(err);
        }

    }, [account, etherQuizWorldContract]);
};
